import { useEffect, useState } from 'react';

const phrases = [
  { text: 'Thinking', delay: 0 },
  { text: '', delay: 0 },
  { text: 'Processing your request, this should take just a moment', delay: 1000 },
  { text: 'Still working on it', delay: 1000 + 3000 },
  { text: 'Finalising my response', delay: 1000 + 3000 + 4000 }
] as const;

export function useLoadingText(firstChunkArrived: boolean) {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const timeouts: ReturnType<typeof setTimeout>[] = [];
    if (firstChunkArrived) {
      for (let i = 1; i < phrases.length; i++) {
        timeouts.push(
          setTimeout(() => {
            setPhraseIndex(i);
          }, phrases[i].delay)
        );
      }
    }
    return () => {
      for (const timeout of timeouts) clearTimeout(timeout);
    };
  }, [firstChunkArrived]);

  return { text: phrases[phraseIndex].text } as const;
}
